import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CommissionBlock from './components/CommissionBlock';
import PiggyMoneyIcon from '../../../../commonComponents/icons/PiggyMoneyIcon';
import WithdrawIcon from '../../../../commonComponents/icons/WithdrawIcon';
import WalletProp, { WALLET_TYPE } from '../../proptype/walletProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';
import { formatNumber } from '../../../../services/numberUtilis';

function WalletCommissionInfo(props) {
  const { t, wallet } = props;
  const {
    totalPayments = 0,
    userPriceTotalPayments,
    totalPayouts = 0,
    userPriceTotalPayouts,
    type,
    currencyInfo,
    coinsPayments = 0,
  } = wallet || {};
  const isWalletCoins = type === WALLET_TYPE.COINS;

  const totalOfPaymentsTxt = useMemo(() => {
    switch (type) {
      case WALLET_TYPE.FIAT:
      case WALLET_TYPE.CRYPTO:
        return t('commissions.total.totalCommissions');
      case WALLET_TYPE.COINS:
        return t('total.of.coins');
      default:
        return null;
    }
  }, [t, type]);

  const totalOfPayments = useMemo(() => {
    switch (type) {
      case WALLET_TYPE.FIAT:
        return newFormatPrice(
          parseFloat(Math.floor(parseFloat(userPriceTotalPayments?.price))) ||
            0,
          true,
          userPriceTotalPayments.code,
        );
      case WALLET_TYPE.CRYPTO:
        return `${totalPayments}${currencyInfo.symbol}`;
      case WALLET_TYPE.COINS:
        return formatNumber(coinsPayments);
      default:
        return null;
    }
  }, [userPriceTotalPayments, totalPayments, currencyInfo, coinsPayments]);

  const totalOfPayouts = useMemo(() => {
    switch (type) {
      case WALLET_TYPE.FIAT:
        return newFormatPrice(
          parseFloat(Math.floor(parseFloat(userPriceTotalPayouts?.price))) || 0,
          true,
          userPriceTotalPayouts.code,
        );
      case WALLET_TYPE.CRYPTO:
        return `${totalPayouts}${currencyInfo.symbol}`;
      case WALLET_TYPE.COINS:
        return formatNumber(totalPayouts);
      default:
        return null;
    }
  }, [userPriceTotalPayouts, totalPayouts, currencyInfo]);

  return (
    <div className="commission-block-containers">
      <CommissionBlock
        label={totalOfPaymentsTxt}
        textColor="#1BADFF"
        backgroundColor="#1BADFF26"
        icon={<PiggyMoneyIcon />}
        value={totalOfPayments}
        tooltip={{
          label: t('commissions.total.totalCommissions'),
          content: t('commissions.total.totalCommissions.tooltip'),
        }}
      />
      {!isWalletCoins ? (
        <CommissionBlock
          label={t('commissions.total.withdraws')}
          textColor="#8029EF"
          backgroundColor="#8029EF26"
          icon={<WithdrawIcon />}
          value={totalOfPayouts}
          tooltip={{
            label: t('commissions.total.withdraws'),
            content: t('commissions.total.withdraws.tooltip'),
          }}
        />
      ) : null}
    </div>
  );
}

WalletCommissionInfo.propTypes = {
  t: PropTypes.string.isRequired,
  wallet: PropTypes.shape(WalletProp.propType).isRequired,
};
WalletCommissionInfo.defaultProps = {};

export default translate(WalletCommissionInfo);
